/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { Button, Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { Container, Table } from 'react-bootstrap';
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Game, Player } from "../models";
import { fetchByPath, validateField } from "./utils";
import { SortDirection, DataStore, Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import ResumeModal from "./ResumeModal";
import useActiveGame from "../hooks/useActiveGame";

export default function GameCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    GameDate: "",
    GameLead: "",
  };
  const [GameDate, setGameDate] = React.useState(initialValues.GameDate);
  const [GameLead, setGameLead] = React.useState(initialValues.GameLead);
  React.useEffect(()=>{
    getOwner().then(u => setGameLead(u));
    setGameDate(new Date().toISOString());
  },[]);
  const [errors, setErrors] = React.useState({});
  
  const [gameInfo, setGameInfo] = React.useState()
  async function getGames() { 
   let o= await getOwner()
    console.log(o)
    let newGameInfo = []
    let promises = []
    let games = await DataStore.query(Game, f => f.GameLead.eq(o), {
      sort: s => s.GameDate(SortDirection.DESCENDING)
    })
            games.forEach((game) => {
      let summary = ""
      let playerPromise = new Promise((resolve, reject) => {
          let players= DataStore.query(Player, p => p.gameID.eq(game.id), {
            sort: s => s.total(SortDirection.DESCENDING)
          }).then((players) => {
            if(players.length > 0) {
              players.forEach((p) => {
                summary = summary.concat("(",p.Name," ",p.total ? p.total : 0,") ")
              })
              let d= new Date(game.GameDate)
              console.log(d.toLocaleString(), summary)
              newGameInfo.push({ GameDate: d.toLocaleString(), Summary: summary })
              newGameInfo[newGameInfo.length-1].Game = game.GameType || 'Grass';
              resolve()
            } else {
              reject()
            }
          })
      })
      promises.push(playerPromise)
    })
    await Promise.allSettled(promises).then(() => setGameInfo(newGameInfo))
  }
  async function getOwner() {
    let user = await Auth.currentAuthenticatedUser();
    return user.username;
  }
  const navigate= useNavigate();
  const { list } = useActiveGame();
  const [showResume, setShowResume] = React.useState(false);

  

  return (
    <Container>
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
        onSubmit={async (event) => {
        event.preventDefault();
        console.log("Submit:", GameDate, GameLead)
        let modelFields = {
          GameDate,
          GameLead,
        };
          // explicitly set GameType for new Grass games
          modelFields.GameType = 'Grass';
          let g= new Game(modelFields);
          await DataStore.save(g);
          console.log("game: ", g);
          navigate("/gamesetup", { state: {game: g }  });
        
      }}
      {...rest}
    >
      
      <Flex
        justifyContent="center"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
            children="Start New Grass Game"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
      </Flex>

      <Flex justifyContent="center" {...getOverrideProps(overrides, "CTAFlex")}>
        <Button onClick={() => navigate("/golf")}>Start New Golf Game</Button>
      </Flex>

      <Flex justifyContent="center" {...getOverrideProps(overrides, "CTAFlex")}>
        <Button onClick={() => getGames()}>Game History</Button>
      </Flex>

      <Flex justifyContent="center" {...getOverrideProps(overrides, "CTAFlex")}>
        <Button onClick={() => setShowResume(true)} isDisabled={!list || list.length === 0}>Resume Games</Button>
      </Flex>

      <Flex justifyContent="center" {...getOverrideProps(overrides, "CTAFlex")}>
        <Button onClick={() => navigate("/player")}>Friends</Button>
      </Flex>
      <ResumeModal show={showResume} onClose={() => setShowResume(false)} />
    </Grid>
    <Container>
      {gameInfo && 
        <Table size="sm">
          <thead>
            <tr>
              <th>Date</th>
              <th>Game</th>
              <th>Scores</th>
            </tr>
          </thead>
          <tbody>
            {gameInfo.map((item, i) => (
              <tr key={i}>
                <td>{item.GameDate}</td>
                <td>{item.Game || 'Grass'}</td>
                <td>{item.Summary}</td>
              </tr>
            ))}
          </tbody>
        </Table>}
    </Container>
    </Container>
  );
}
